/* unplugin-vue-components disabled */import script from "./XTableSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./XTableSelect.vue?vue&type=script&setup=true&lang=ts"

import "./XTableSelect.vue?vue&type=style&index=0&id=3bcc19e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bcc19e1"]])

export default __exports__